import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import Loader from './Loader';
import { REMOVE_PHOTO } from '../../../redux/Ads';

const Photothumbnail = ({ thumbUrl, onClick, id, removeExistingPhoto,
                          match: { params: { adId, }, }, closeIconStyles, }) => {
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles({ isLoading, closeIconStyles, });
  return (
    <div
      className={classes.photothumbnail}
    >
      <div
        className={classes.close}
        onClick={() => {
          setIsLoading(true);
          removeExistingPhoto({ photoId: id, adId, });
        }}
      />
      <div
        style={{ backgroundImage: `url(${thumbUrl})`, }}
        className={classes.image}
        onClick={onClick}
      >
      </div>
      {isLoading &&
        <div className={classes.loaderContainer}>
          <Loader />
        </div>
      }
    </div>
  );
};

Photothumbnail.propTypes = {
  thumbUrl: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  id: PropTypes.string.isRequired,
  removeExistingPhoto: PropTypes.func.isRequired,
  closeIconStyles: PropTypes.object,
};

Photothumbnail.defaultProps = {
  onClick: () => null,
  closeIconStyles: {},
  hashId: null,
};

const useStyles = createUseStyles({
  photothumbnail: {
    position: 'relative',
  },
  image: (props) => ({
    marginRight: '1em',
    borderRadius: '10px',
    height: '110px',
    backgroundSize: '170px',
    backgroundPosition: 'center',
    cursor: 'pointer',
    marginTop: '0.5em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    WebkitFilter: `brightness(${props.isLoading ? '20' : '100'}%)`,
  }),
  loaderContainer: {
    position: 'absolute',
    top: '45%',
    left: '35%',
  },
  close: (props) => ({
    position: 'absolute',
    right: '20px',
    top: '-5px',
    width: '15px',
    height: '15px',
    cursor: 'pointer',
    opacity: '0.8',
    ...props.closeIconStyles,
    '&:hover': {
      opacity: '1',
    },
    '&:before': {
      content: '\'\'',
      position: 'absolute',
      left: '15px',
      height: '15px',
      width: '4px',
      backgroundColor: '#333',
      transform: 'rotate(45deg)',
    },
    '&:after': {
      content: '\'\'',
      position: 'absolute',
      left: '15px',
      height: '15px',
      width: '4px',
      backgroundColor: '#333',
      transform: 'rotate(-45deg)',
    },
  }),
});

const mapDispatchToProps = (dispatch) => {
  return {
    removeExistingPhoto: (params) => dispatch(REMOVE_PHOTO(params)),
  };
};

export default compose(connect(null, mapDispatchToProps), withRouter)(Photothumbnail);
